function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "ssoqzb86ra",
  width: "165.7%",
  height: "201.1%",
  x: "-32.9%",
  y: "-50.5%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("g", {
  filter: "url(#ssoqzb86ra)",
  transform: "translate(-394 -311) translate(394 310)"
}, React.createElement("g", {
  fillRule: "nonzero",
  transform: "translate(22 41)"
}, React.createElement("rect", {
  width: 68,
  height: 28,
  x: .76,
  y: .12,
  fill: "#F97F55",
  rx: 4.8
}), React.createElement("path", {
  fill: "#FFF",
  d: "M19.426 20.447c3.476 0 5.585-2.49 5.585-6.379 0-3.906-2.126-6.37-5.585-6.37-3.443 0-5.586 2.455-5.586 6.37 0 3.898 2.092 6.379 5.586 6.379zm0-1.4c-2.532 0-4.025-1.958-4.025-4.979 0-3.046 1.544-4.97 4.025-4.97 2.489 0 4.024 1.924 4.024 4.97 0 3.02-1.527 4.978-4.024 4.978zm9.324 1.113V7.453h-1.451V20.16h1.45zm3.333-10.85c.557 0 1.013-.456 1.013-1.013 0-.557-.456-1.013-1.013-1.013-.557 0-1.012.456-1.012 1.013 0 .557.455 1.012 1.012 1.012zm.726 10.85v-9.096h-1.451v9.096h1.451zm6.582 0l3.367-9.096h-1.553l-2.489 7.493h-.135l-2.49-7.493H34.54l3.367 9.096h1.485zm5.823-10.85c.556 0 1.012-.456 1.012-1.013 0-.557-.456-1.013-1.012-1.013-.557 0-1.013.456-1.013 1.013 0 .557.456 1.012 1.013 1.012zm.725 10.85v-9.096h-1.451v9.096h1.451zm5.055.16c1.215 0 2.21-.531 2.801-1.502h.135v1.342h1.384v-6.227c0-1.89-1.24-3.029-3.46-3.029-1.94 0-3.374.962-3.568 2.422h1.468c.202-.718.962-1.131 2.05-1.131 1.358 0 2.059.616 2.059 1.738v.827l-2.624.16c-2.118.127-3.316 1.063-3.316 2.692 0 1.662 1.308 2.708 3.071 2.708zm.27-1.274c-1.055 0-1.84-.54-1.84-1.468 0-.911.608-1.392 1.992-1.485l2.447-.16v.835c0 1.3-1.106 2.278-2.599 2.278z"
})), React.createElement("path", {
  fill: "#F97F55",
  d: "M108.176 13.552l12.76 25.52c.711 1.423.135 3.153-1.288 3.864-.81.405-1.765.405-2.576 0L105.6 37.2l-11.472 5.736c-1.423.711-3.153.135-3.864-1.288-.405-.81-.405-1.765 0-2.576l12.76-25.52c.711-1.423 2.441-2 3.864-1.288.557.279 1.01.73 1.288 1.288z",
  transform: "scale(-1 1) rotate(-45 0 282.541)"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 140,
    height: 90,
    viewBox: "0 0 140 90"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/olivia-cursor.c36a588e.svg";
export { SvgComponent as ReactComponent };